import { GxSpinner } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from './styles/spinner.module.scss'

const Spinner = ({ color = 'white', ...props }): React.ReactElement => {
  return <GxSpinner className={style[`spinner_${color}`]} {...props} />
}

export default Spinner
